import React, { useRef, useEffect } from 'react';

const OutsideClickHandler = ({ children, onOutsideClick = () => {} }) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const wrapperRef = useRef(null);

  /* ===== Hooks ===== */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onOutsideClick();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onOutsideClick]);

  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return <div ref={wrapperRef}>{children}</div>;
};

export default OutsideClickHandler;
